// src/domains/types.ts
import type { Domain, DomainCtx } from '../../../shared/src/dc';
import type { AgentGp } from '../gp';
import type { AgentState } from '../state';

export type AgentCtx = DomainCtx<AgentState, AgentGp>;

export interface AgentDomain extends Domain<AgentState, AgentGp> {
  readonly keys: readonly string[];
  readonly modalKeys: readonly string[];
  readonly migrated: boolean;
  modal?(ctx: AgentCtx): Record<string, unknown>;
}

export interface InputEvent {
  target: { value: string };
}

export interface ClickEvent {
  stopPropagation(): void;
}

export function str(t: Readonly<Record<string, unknown>>, k: string): string {
  const v = t[k];
  return typeof v === 'string' ? v : '';
}

export function strs(t: Readonly<Record<string, unknown>>, k: string): readonly string[] {
  const v = t[k];
  return Array.isArray(v) ? v.filter((x): x is string => typeof x === 'string') : [];
}
